<template>
  <div>
    <BatchTable
      :orderInspectionDocCode="orderInspectionDocCode"
      :orderCode="orderCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      isExpand
    />
  </div>
</template>
<script>
import BatchTable from './components/order-batch'
export default {
  components: { BatchTable },
  props: {
    orderInspectionDocCode: String,
    orderCode: String,
    disabled: { type: Boolean, default: false },
  },
}
</script>
